import MatchRowTeaser from 'app/components/matchRow/teaser/MatchRowTeaser';
import React from 'react';
import createRenderedViewsFromArray from 'app/components/swipeableViews/createRenderedViewsFromArray';
import SwipeableViewsStepper from 'app/components/swipeableViews/SwipeableViewsStepper';
import { MatchesView, Wrapper } from 'app/components/competitionModule/matches/commonStyles';
import { MatchRowTeaserWrapper } from 'app/components/matchRow/teaser/teaserStyles';
import SectionHeading from 'app/components/competitionModule/common/SectionHeading';
const MATCHES_PER_VIEW = 8;
export default function CompetitionModuleMatches(_ref) {
  let {
    competitionSlug,
    matches
  } = _ref;
  if (!matches.length) {
    return null;
  }
  const createListElement = match => /*#__PURE__*/React.createElement(MatchRowTeaser, {
    key: match.slug,
    match: match,
    "data-sentry-element": "MatchRowTeaser",
    "data-sentry-component": "createListElement",
    "data-sentry-source-file": "CompetitionModuleMatches.tsx"
  });
  const createFillerElement = index => /*#__PURE__*/React.createElement(MatchRowTeaserWrapper, {
    key: "".concat(competitionSlug, "-match-filler-").concat(index),
    "data-sentry-element": "MatchRowTeaserWrapper",
    "data-sentry-component": "createFillerElement",
    "data-sentry-source-file": "CompetitionModuleMatches.tsx"
  });
  const views = createRenderedViewsFromArray(matches, createListElement, createFillerElement, MATCHES_PER_VIEW, true);
  return /*#__PURE__*/React.createElement(Wrapper, {
    "data-sentry-element": "Wrapper",
    "data-sentry-component": "CompetitionModuleMatches",
    "data-sentry-source-file": "CompetitionModuleMatches.tsx"
  }, /*#__PURE__*/React.createElement(SectionHeading, {
    "data-sentry-element": "SectionHeading",
    "data-sentry-source-file": "CompetitionModuleMatches.tsx"
  }, "Aktuelle Spiele"), /*#__PURE__*/React.createElement(SwipeableViewsStepper, {
    views: views,
    hideStepperWithoutPages: true,
    viewRender: _ref2 => {
      let {
        index
      } = _ref2;
      return /*#__PURE__*/React.createElement(MatchesView, {
        key: "".concat(competitionSlug, "-matches-view-").concat(index)
      }, views[index]);
    },
    "data-sentry-element": "SwipeableViewsStepper",
    "data-sentry-source-file": "CompetitionModuleMatches.tsx"
  }));
}